import React, { useEffect, useRef } from 'react';
import Button from '../../../../../../core/button/Button';

interface AttributeDisplayProps {
  attributes: { [key: string]: any } | null;
  visible: boolean;
  onClose: () => void;
  onAttributeClick: (property: string, value: any) => void;
}

const AttributeDisplay: React.FC<AttributeDisplayProps> = ({ attributes, visible, onClose, onAttributeClick }) => {
  const panelRef = useRef<HTMLDivElement>(null);

  console.log('AttributeDisplay props:', { visible, attributes });

  useEffect(() => {
    console.log('AttributeDisplay props updated:', { visible, attributes });
  }, [visible, attributes]);

  // Handle click outside to close
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (visible && panelRef.current && !panelRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (visible) {
      // Add event listener when panel is visible
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      // Clean up event listener
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [visible, onClose]);

  if (!visible || !attributes) {
    console.log('AttributeDisplay not rendering - visible:', visible, 'attributes:', attributes);
    return null;
  }

  console.log('AttributeDisplay rendering with attributes:', attributes);

  // Filter out null and undefined values before rendering
  const validAttributes = Object.entries(attributes).filter(
    ([_, value]) => value !== null && value !== undefined
  );

  return (
    <div 
      ref={panelRef}
      className="fixed top-20 left-96 z-50 w-96 bg-surface-default border border-border-default rounded-2xl shadow-lg max-h-[80vh] overflow-hidden"
    >
      <div className="flex items-center justify-between p-4 border-b border-border-subdued">
        <h3 className="text-lg font-semibold text-text-default">Object Attributes</h3>
        <Button
          variant="shapeless"
          size="sm"
          square
          leadingIcon="close-md"
          onClick={onClose}
          aria-label="Close"
        />
      </div>
      
      <div className="overflow-y-auto max-h-96">
        <div className="divide-y divide-border-subdued">
          {validAttributes.map(([key, value]) => (
            <div 
              key={key} 
              onClick={() => onAttributeClick(key, value)} 
              className="flex items-center justify-between p-3 hover:bg-surface-highlight-subdued cursor-pointer transition-colors"
            >
              <div className="flex-1 min-w-0">
                <div className="body-md text-text-subdued truncate">{key}</div>
                <div className="body-md-bold text-text-default break-words">{String(value)}</div>
              </div>
              <div className="ml-3 text-icon-subdued">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AttributeDisplay; 